export { useResetIconStyle as default } from '../../theme/internal';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/config-provider/style/index.js
// module id = 1497
// module chunks = 0